import React from 'react';

import AuthFormBlock from '../../components/UI/AuthFormBlock';

const LoginPage = () => {
  return <AuthFormBlock />;
};

export default LoginPage;
